import { Box, styled } from '@mui/material';

export const CustomerTableBox = styled(Box)(({ theme }) => ({
  flex: 1.5,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0, 0, 0, 1),
  margin: theme.spacing(1, 0),
}));

export const MenuIconBox = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(0, 1, 1, 0),
  alignItems: 'center',
  display: 'flex',
}));

export const OrderCardItem = styled(Box)(({ theme }) => ({
  minHeight: '70px',
  display: 'flex',
  width: 'full',
  backgroundColor: theme.palette.background.default,
  margin: theme.spacing(0.25, 0, 0.75, 0),
  borderRadius: theme.spacing(2),
  border: `solid 1px ${theme.palette.general.lightGrey4}`,
}));

export const OrderIdBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0.1),
  width: '60px',
  fontSize: theme.spacing(0),
  margin: theme.spacing(0, 0, 0.25, 0),
  backgroundColor: theme.palette.primary.main,
  borderRadius: theme.spacing(1),
  textAlign: 'center',
  cursor: 'pointer',
}));

export const TableBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  marginTop: theme.spacing(0.25),
}));

export const TimeBox = styled(Box)(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.spacing(0, 1, 1, 0),
}));

export const TimeTableBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flex: 1.25,
  backgroundColor: theme.palette.general.lightGrey4,
  borderRadius: theme.spacing(0, 1.5, 1.5, 0),
}));
